import React from 'react';

import { WebchatPreChat } from 'modules/webchat/presentation/components/organisms';

import { WebchatProvider } from './WebchatContext';

export * from './WebchatContext';

/**
 * Webchat da Callbell (ED-7260), o canal de atendimento que substitui o botão
 * flutuante do WhatsApp. Fica acima das rotas para o chat existir em todas as
 * páginas: o nosso botão abre o pré-chat do visitante e, depois dele ou com
 * cliente logado, o próprio widget desenha o botão flutuante.
 */
export const WebchatGlobalContainer: React.FC = ({ children }) => (
  <WebchatProvider>
    {children}
    <WebchatPreChat />
  </WebchatProvider>
);
